module.exports = __webpack_public_path__ + "img/tarif_komoditas.698deacb.svg";